import { Button } from "@headlessui/react";
import { useContentful } from "react-contentful";
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionGroup } from "../components/Accordion";
import Container from "../components/Container";
import Header from "../components/Header";
import EN from "../locales/en";

const Faqs = () => {
  const navigate = useNavigate();
  const { data, error, fetched, loading } = useContentful({
    contentType: "switchingFaq",
  });

  if (loading || !fetched) {
    return null;
  }

  if (error) {
    console.error(error);
    return null;
  }

  if (!data) {
    return <p>Page does not exist.</p>;
  }

  return (
    <Container>
      <Button
        className="flex items-center text-primary mb-4"
        onClick={() => navigate(-1)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={3}
          stroke="currentColor"
          className={`flex-shrink-0 size-5 text-primary rotate-90`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
        <span className="ml-2 text-left">Back</span>
      </Button>
      <Header title={EN.faqs.title} />

      <div className="mt-4">
        <AccordionGroup>
          {data?.items?.map((item) => (
            <Accordion
              key={item?.fields?.slug}
              id={item?.fields?.slug}
              title={item?.fields?.question}
              content={item?.fields?.answer}
            />
          ))}
        </AccordionGroup>
      </div>
    </Container>
  );
};

export default Faqs;
